﻿import { TagID } from "src/entities/tagid";
import { ICloudStorageAccess } from "../cloudstorage/cloudStorageAccess";

export default class TagSelectorWidget {
  // TODO: Promise<any> を明確にする
  public onSelect: (t: TagID) => Promise<any>;

  private container: HTMLElement;
  private openBtn: HTMLButtonElement;
  private tagListPane: HTMLDivElement;

  private repository: ICloudStorageAccess;
  private tags: TagID[];

  constructor(container: HTMLElement | null, repository: ICloudStorageAccess) {
    if (!container) throw new Error("container is null");
    this.container = container;
    this.repository = repository;
  }

  public render() {
    console.debug("render tag-selector widget");

    if (!this.onSelect) throw new Error(`'onSelect must be set'`);

    this.repository
      .listTags()
      .then((tags: TagID[]) => {
        this.tags = tags;
        console.debug(`tags: ${tags}`);

        //
        // タグ一覧の表示ボタン
        //
        const openBtn = document.createElement("button");
        openBtn.classList.add(
          "tag-selector__open",
          "display-none",
          "navi__button",
        );
        openBtn.classList.add("tag-selector__toggle");
        openBtn.textContent = "台紙選択";
        openBtn.onclick = () => this.open();
        this.openBtn = openBtn;
        this.container.appendChild(openBtn);

        //
        // タグ一覧
        //
        this.tagListPane = document.createElement("div");
        this.tagListPane.classList.add(
          "tag-selector__list__wrapper",
          "unselectable",
        );
        this.tagListPane.onclick = (ev: MouseEvent) => {
          this.close();
          ev.preventDefault();
        };
        this.container.appendChild(this.tagListPane);

        const ul = document.createElement("ul");
        ul.classList.add("tag-selector__list");
        this.tags.forEach((tag: TagID) => {
          let li = document.createElement("li");
          li.classList.add("tag-selector__list__item");
          li.innerHTML = `<span class="tag-id">${tag.toString()}</span>`;
          li.onclick = () => {
            this.onSelect(tag).then(() => {
              this.close();
            });
          };
          ul.appendChild(li);
        });
        this.tagListPane.appendChild(ul);
      })
      .then(() => this.close()) // 初期状態は閉じておく
      .catch((reason) => console.error(reason));
  }

  public open() {
    this.openBtn.classList.add("display-none");
    this.tagListPane.classList.remove("display-none");
  }

  public close() {
    this.openBtn.classList.remove("display-none");
    this.tagListPane.classList.add("display-none");
  }
}
